import { useState } from "react";
import Trigger from "./Components/Chatbot/Trigger";
import Navbar from "./Components/Navbar/Navbar";
import ScrollToTop from "./Components/ScrollToTop/ScrollToTop";
import About from "./Pages/About/About";
import Contact from "./Pages/Contact/Contact";
import Footer from "./Pages/Footer/Footer";
import Hero from "./Pages/Hero/Hero";
import Projects from "./Pages/Projects/Projects";
import Skills from "./Pages/Skills/Skills";

function App() {
  const [showChatbot, setShowChatbot] = useState(false);

  return (
    <div className="app-container">

      <Navbar />
      <Hero />
      <About />
      <Projects />
      <Skills />
      <Contact />
      <Footer />

      <ScrollToTop />

      {/* Chatbot Section */}
      <Trigger showChatbot={showChatbot} setShowChatbot={setShowChatbot} />

    </div>
  );
}

export default App;
